module.exports = __webpack_public_path__ + "assets/img/black-eagle.b68959e0.jpg";